import React, { Component } from 'react';
import { Avatar, Drawer, Divider } from 'antd';
import { MailOutlined, UserOutlined, CalendarOutlined } from '@ant-design/icons';

export class UserView extends Component {
  render() {
    const { data, visible, close } = this.props;
    return (
      <Drawer width={300} placement="right" onClose={close} closable={false} visible={visible}>
        <div className="text-center mt-3">
          <Avatar size={80} src={data?.user?.avatar_url} />
          <h3 className="mt-2 mb-0">{`${data?.user?.first_name} ${data?.user?.last_name}`}</h3>
          {/* {data?.user?.personalInfo.title} */}
          <span className="text-muted">{data?.user?.role}</span>
        </div>
        <Divider dashed />
        <div className="">
          <h6 className="text-muted text-uppercase mb-3">Detalles del Usuario</h6>
          <p>
            <UserOutlined />
            <span className="ml-3 text-dark">Usuario: {data?.user?.user_name}</span>
          </p>
          <p>
            <CalendarOutlined />
            <span className="ml-3 text-dark">
              Fecha Nac: {data?.user?.date_of_birth ? data?.user?.date_of_birth : 'No disponible'}
            </span>
          </p>
        </div>
        <div className="mt-5">
          <h6 className="text-muted text-uppercase mb-3">CONTACTO</h6>
          {/* <p>
            <MobileOutlined />
            <span className="ml-3 text-dark">
              {data?.user?.phone_number ? data?.user?.phone_number : '-'}
            </span>
          </p> */}
          <p>
            <MailOutlined />
            <span className="ml-3 text-dark">{data?.user?.email ? data?.user?.email : '-'}</span>
          </p>
          {/* <p>
            <CompassOutlined />
            <span className="ml-3 text-dark">
              {data?.user?.location ? data?.user?.location : '-'}
            </span>
          </p> */}
        </div>
        {/* <div className="mt-5">
          <h6 className="text-muted text-uppercase mb-3">Social profiles</h6>
          <p>
            <FacebookOutlined />
            <a href="/#" className="ml-3 text-dark">
              {data?.personalInfo.facebook ? data?.personalInfo.facebook : '-'}
            </a>
          </p>
          <p>
            <TwitterOutlined />
            <a href="/#" className="ml-3 text-dark">
              {data?.personalInfo.twitter ? data?.personalInfo.twitter : '-'}
            </a>
          </p>
          <p>
            <InstagramOutlined />
            <a href="/#" className="ml-3 text-dark">
              {data?.personalInfo.instagram
                ? data?.personalInfo.instagram
                : '-'}
            </a>
          </p>
          <p>
            <GlobalOutlined />
            <a href="/#" className="ml-3 text-dark">
              {data?.personalInfo.site ? data?.personalInfo.site : '-'}
            </a>
          </p>
        </div> */}
      </Drawer>
    );
  }
}

export default UserView;
